import { useState } from "react";

export const Mascot = ({ className = "w-9 h-9", variant = "mark" }) => {
  const [failed, setFailed] = useState(false);
  const src = failed ? "/mascot.svg" : variant === "full" ? "/mascot.png" : "/mascot-mark.png";
  return (
    <img
      src={src}
      onError={() => setFailed(true)}
      alt="ScamLizard mascot"
      className={`${className} ${variant === "mark" ? "rounded-full object-cover" : ""}`}
      data-testid="mascot-image"
      draggable={false}
    />
  );
};
